module.exports = __webpack_public_path__ + "static/media/luleakommun.0324ca69.png";